import { version } from '../../package.json'
import UAParser from 'ua-parser-js'

let isDev
let debug
let rootDomain = 'com'
let devRootDomain = 'nutsb.com'
if (process.env.NODE_ENV !== 'production' || window.location.href.match(devRootDomain)) {
  isDev = true
  debug = true
  rootDomain = devRootDomain
} else {
  isDev = false
  debug = false
}

let UA = new UAParser()
let ua = UA.getResult()
let isMobile = ua.device.type === 'mobile'
if (window.innerWidth <= 480) { // 要跟 index.css 保持同步
  isMobile = true
}
let baseDomain = `dartcome.${rootDomain}`

let state = {
  version,
  isDev,
  debug,
  baseDomain,
  UA,
  ua,
  isMobile,
  imgUrl: `https://img.${baseDomain}`,
  /**
   * nutsbp-config
   */
  nutsbpConfigUrl: `https://static.thomas.nutsbp.com/nutsbp-config`,
  /**
   * nutsbp editor
   */
  editorUrlV3: `https://edit.nutsbp.${rootDomain}`,
  editorUrlV4: `https://bp.nutsbp.${rootDomain}`,
  editorUrlSignup: `https://bp.nutsbp.${rootDomain}/#/signUp`,
  editorUrlForget: `https://bp.nutsbp.${rootDomain}/#/Forget`,
  previewUrl: `https://editor.nutsbp.${rootDomain}/preview`,
  get downloadUrl () {
    if (isMobile) {
      return `https://download.nutsbp.${rootDomain}`
    }
    return `https://m.nutsbp.${rootDomain}`
  },
  get editorApiUrlV1 () {
    if (isDev) {
      return `https://api.bp.nutsb.com`
    }
    return `https://api.nutsbp.com`
  },
  editorApiUrlV2: `https://api.thomas.nutsbp.${rootDomain}`,
  /**
   * apis
   */
  ranchApiUrl: `https://api.ranch.nutsbp.${rootDomain}`,
  apiUrlV1: `https://api.${baseDomain}/v1.0`,
  apiUrlV2: `https://${baseDomain}`
}

export default state



// WEBPACK FOOTER //
// ./src/env.js